import { Navigate } from 'react-router-dom'

import { hasDelmanDevice } from '@/shared/auth/delmanDeviceStorage'
import { hasDelmanSession } from '@/shared/auth/delmanSessionStorage'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

export function DelmanEntryRedirect() {
  const hydrated = useClientHydrated()

  if (!hydrated) {
    return (
      <div className="min-h-[200px] flex items-center justify-center" aria-busy>
        <span className="material-symbols-outlined text-primary text-3xl animate-spin">progress_activity</span>
      </div>
    )
  }
  if (!hasDelmanDevice()) return <Navigate to="/delman/activate" replace />
  if (hasDelmanSession()) return <Navigate to="/delman/trip" replace />
  return <Navigate to="/delman/login" replace />
}
